import { base64 } from '../utils/index'

const state = {
  fundsAuth: localStorage.getItem('A') ? JSON.parse(base64.decode(localStorage.getItem('A'))) : '',
  userRole: localStorage.getItem('R') ? JSON.parse(base64.decode(localStorage.getItem('R'))) : '',
  userInfo: localStorage.getItem('I') ? JSON.parse(base64.decode(localStorage.getItem('I'))) : '',
  homeInfo: localStorage.getItem('H') ? JSON.parse(base64.decode(localStorage.getItem('H'))) : '',
  // 面包屑
  bread: localStorage.getItem('bread')
    ? JSON.parse(localStorage.getItem('bread'))
    : {
        oB: 'home.ihome',
        topPath: 1,
        children: [
          {
            name: 'home.ihome',
            path: '/home',
          },
        ],
      },
  // 左侧list
  leftList: [],
  listType: localStorage.getItem('ListType') ? localStorage.getItem('ListType') : 1, //1 真实 0 模拟
  accountType: localStorage.getItem('at') ? localStorage.getItem('at') : '',
  leftActive: localStorage.getItem('leftActive') ? localStorage.getItem('leftActive') : 1,
  // 名下用户展开数组
  expandedKey: [],
  showBindBox: 0,
  banner: {
    home: {},
    firstCharge: {},
    contact: {},
  },
  hostname: 'prowayxau',
  wwwUrl: '',
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js